import { useEffect, useState } from 'react';
import '../css/process.css'
import { useNavigate } from "react-router-dom";
import config from '../Context/Config';
import Swal from 'sweetalert2';
import Background from '../Components/background/background';

const ProcessPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getFormInfo();
    },[]);


    const getFormInfo = async () => {
        setLoading(true);
        
        try {

            // Make API call to get form information
            const response = await fetch(`${config.API_BASE_URL}/form_info`, {
                method: "GET",
                headers: { 
                    "Content-Type": "application/json",
                    "Authorization": config.accessToken || ""
                },
            });

            if (!response.ok) {
                if (response.status === 400) {
                    showErrorAlert("Invalid authorization code. Please try logging in again.");
                } else if (response.status === 401) {
                    showErrorAlert("Authentication failed. Please try logging in again.");
                } else if (response.status >= 500) {
                    showErrorAlert("Server error. Please try again later.");
                } else {
                    showErrorAlert("Authentication failed. Please try again.");
                }
                return;
            }

            const message = await response.json();
            config.practice = message['practice'];

            
            navigate(`/${message['formType']}`, { state: { openedViaLogin: true, show: message['show'] === "true" ? true : false } });
            
            
        } catch (error) {
            // Only log detailed errors in development
            if (process.env.NODE_ENV === 'development') {
                console.error("Error in getFormInfo:");
            }
            
            showErrorAlert("Unable to complete authentication. Please try again.");
        } finally {
            setLoading(false);
        }
    };

       const clearAuthData = () => {
        config.accessToken = null;
        config.token = null;
        config.practice = null;
    };

      const showErrorAlert = (message = "An unexpected error occurred. Please try again later.") => {
            Swal.fire({
                icon: "error",
                title: "Authentication Error",
                text: message,
                confirmButtonText: "Return to Login",
                allowOutsideClick: false
            }).then(() => {
                clearAuthData();
                navigate("/");
            });
        };
    

    return (
        <div className="relative h-screen w-screen bg-white overflow-hidden">
            {/* Animated Background */}
            <Background />

            {/* Loading Indicator */}
            {loading && (
                <div className="absolute inset-0 flex justify-center items-center z-10">
                    <div className="cloud"></div>
                </div>
            )}
        </div>
    );
};

export default ProcessPage;